import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-444cba8a")

_pushScopeId("data-v-444cba8a")
const _hoisted_1 = { class: "wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_slide_item = _resolveComponent("slide-item")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_answer_button = _resolveComponent("answer-button")
  const _directive_touch_swipe = _resolveDirective("touch-swipe")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: "carousel row no-wrap q-mt-md justify-start items-start",
      style: { ..._ctx.positionStyleObject }
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.message.slides, (slide, index) => {
        return (_openBlock(), _createBlock(_component_slide_item, {
          key: index,
          slide: slide,
          style: { opacity: _ctx.isHiddenSlide(index + 1) ? '0.5' : '1' },
          onClickButtonWithPayload: _cache[1] || (_cache[1] = payload => _ctx.$emit('send-message', payload)),
          class: "q-mr-sm",
          id: `slide-${index}`
        }, null, 8, ["slide", "style", "id"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 4), [
      [
        _directive_touch_swipe,
        _ctx.handleSwipe,
        void 0,
        {
          horizontal: true,
          mouse: true
        }
      ]
    ]),
    (!_ctx.isPhoneSize || _ctx.isWidget)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_q_btn, {
            icon: "keyboard_arrow_left",
            color: "black",
            dense: true,
            class: "arrow arrow-left",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.moveRight()), ["stop"]))
          }),
          _createVNode(_component_q_btn, {
            icon: "keyboard_arrow_right",
            color: "black",
            dense: true,
            class: "arrow arrow-right",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.moveLeft()), ["stop"]))
          })
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: ["answer-buttons-wrap", { 'q-mx-auto': !_ctx.isPhoneSize }]
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.message.buttons, (button, index) => {
        return (_openBlock(), _createBlock(_component_answer_button, {
          key: index,
          button: button,
          onClickButtonWithPayload: _cache[4] || (_cache[4] = payload => _ctx.$emit('send-message', payload)),
          style: { ..._ctx.CalculaterButtonWidth(button.width) }
        }, null, 8, ["button", "style"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2), [
      [_vShow, _ctx.isLastMessage]
    ])
  ]))
})